module.exports = __webpack_public_path__ + "static/media/shelter_port_marker.8372e0d8.svg";